import { render, staticRenderFns } from "./top10-viewpoint.vue?vue&type=template&id=338bb4b0&scoped=true"
import script from "./top10-viewpoint.vue?vue&type=script&setup=true&lang=js"
export * from "./top10-viewpoint.vue?vue&type=script&setup=true&lang=js"
import style0 from "./top10-viewpoint.vue?vue&type=style&index=0&id=338bb4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338bb4b0",
  null
  
)

export default component.exports